/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { EuiComboBoxOptionOption } from '@elastic/eui'

export const getSelectedOptions = <RoleId extends string>(
  assignments: Array<{ role_id: RoleId }> | undefined,
  options: Array<EuiComboBoxOptionOption<RoleId>>,
  customRolesEnabled: boolean,
): Array<EuiComboBoxOptionOption<RoleId>> => {
  const selectedOptions: Array<EuiComboBoxOptionOption<RoleId>> = []

  if (assignments?.length) {
    const assignmentsToProcess = customRolesEnabled ? assignments : assignments.slice(0, 1)

    assignmentsToProcess.forEach((assignment) => {
      const found = options.find((option) => option.value === assignment.role_id)

      if (found) {
        selectedOptions.push(found)
      }
    })
  }

  return selectedOptions
}
